import { Badge, Empty, Pagination, Table } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Header from '@/components/list/Header';
import { usePartnerNoticesMain } from '@/hooks/queries/partner';
import usePagination from '@/hooks/usePagination';
import type { PartnerNoticeListItem } from '@/types/partner';

const NoticeList = () => {
  const navigate = useNavigate();
  const pagination = usePagination();
  const query = usePartnerNoticesMain({ ...pagination.query });

  const dataSource = useMemo(() => {
    const pinned = query.data?.pinnedNotices ?? [];
    const regular = query.data?.notices.results ?? [];
    return [...pinned, ...regular];
  }, [query.data]);

  return (
    <div css={tw`flex flex-col gap-[16px]`}>
      <Table<PartnerNoticeListItem>
        title={() => (
          <Header
            showTotalCount
            showSizeSelector
            pagination={{
              total: query.data?.notices.count,
              ...pagination,
            }}
          />
        )}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="등록된 공지사항이 없어요"
            />
          ),
        }}
        scroll={{ x: '100%' }}
        tableLayout="auto"
        showSorterTooltip={false}
        columns={[
          {
            dataIndex: 'title',
            title: '제목',
            width: 'auto',
            render: (value, record) => (
              <span>
                {record.isPinned && (
                  <Badge count="공지" color="#1677ff" css={tw`mr-[8px]`} />
                )}
                <span css={record.isPinned ? tw`font-bold` : tw`font-normal`}>
                  {value}
                </span>
              </span>
            ),
          },
          {
            dataIndex: 'publishedAt',
            title: '작성일',
            width: '15%',
            render: (value) => dayjs(value).format('YYYY-MM-DD'),
          },
        ]}
        dataSource={dataSource}
        rowKey={(row) => row.id}
        pagination={false}
        onRow={(record) => ({
          onClick: () => {
            navigate(`${PATH.NOTICE.INDEX}/${record.id}`);
          },
          role: 'button',
        })}
      />
      {query.data?.notices.count !== undefined && (
        <div css={tw`flex justify-center`}>
          <Pagination
            current={pagination.query.page}
            pageSize={pagination.query.size}
            total={query.data.notices.count}
            onChange={(page, size) =>
              pagination.setPaginationValues({ page, size })
            }
            showQuickJumper={false}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

export default NoticeList;
